import { BridgeComponent } from "@hotwired/hotwire-native-bridge"
import { postJson } from "../lib/http"
import { directUploadImage } from "../lib/thumbnail_backfill"
import { isObjectionable } from "../lib/nsfw"
import { canvasResize, BLUR_PLACEHOLDER } from "../lib/image_resize"

export default class extends BridgeComponent {
  static component = "camera"
  static targets = ["button", "status"]
  connect() {
    super.connect()
    this.disconnected = false
    if (!this.bridge || !window.proximityCameraAvailable) return
    if (this.hasButtonTarget && !this.element.hasAttribute('data-camera-background')) this.buttonTarget.hidden = false
    if (this.hasStatusTarget) this.statusTarget.textContent = ""
    this.element.querySelectorAll('[data-camera-link]').forEach(el => { el.hidden = false })
    if (this.hasButtonTarget) {
      this.onCameraRequest = () => this.capture()
      document.addEventListener('native:camera-request', this.onCameraRequest)
    }
    if (this.hasButtonTarget && (!this.element.hasAttribute('data-camera-background') || new URL(window.location.href).searchParams.get('camera') === '1')) this.capture()
  }
  disconnect() {
    this.disconnected = true
    if (this.onCameraRequest) document.removeEventListener('native:camera-request', this.onCameraRequest)
    super.disconnect()
  }
  capture() {
    if (this.busy || !this.bridge) return
    this.busy = true
    this.buttonTarget.disabled = true
    const account = document.querySelector('meta[name="photo-updates-account"]')?.content
    const current = () => !this.disconnected && account === document.querySelector('meta[name="photo-updates-account"]')?.content
    const handle = async response => {
      try {
        if (!current()) return
        const { photo, error } = response.data || response
        if (error) throw new Error(error)
        if (!photo) return
        this.pendingPhoto = photo
        this.statusTarget.textContent = "Saving your moment…"
        if (await isObjectionable(photo.thumbnail)) {
          this.pendingPhoto = null
          throw new Error("This photo can’t be added to Proximity.")
        }
        if (!current()) return
        const blur = await canvasResize(photo.thumbnail, BLUR_PLACEHOLDER)
        const signed_id = await directUploadImage(photo.thumbnail, photo.client_ref, { shouldContinue: current })
        if (!current()) return
        const { thumbnail, ...metadata } = photo
        const saved = await postJson('/moments', { photo: metadata, signed_id, blur })
        if (!saved.ok) throw new Error("Your photo is saved in Photos. Proximity couldn’t save it. Please try again.")
        const result = await saved.json()
        if (current()) {
          this.pendingPhoto = null
          if (window.proximityCameraDirectAvailable) this.send('openResult', { path: result.url }, () => {})
          else window.Turbo.visit(result.url)
        }
      } catch (error) {
        if (current()) this.statusTarget.textContent = error.message
      } finally {
        this.busy = false
        if (current()) {
          this.buttonTarget.disabled = false
          this.buttonTarget.textContent = this.pendingPhoto ? "Retry saving your moment" : "Take a photo"
        }
      }
    }
    if (this.pendingPhoto) handle({ photo: this.pendingPhoto })
    else this.send("capture", { accountID: Number(account) }, handle)
  }
}
